import React, { Component } from "react"
import ReactDOM from "react-dom"

import Datetime from 'react-datetime'

export default Datetime

